import { collection, query, where, getDocs, doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase/firebaseconfig";

const normalizeWishlistItem = (product) => {
  const isFrame = product?.category?.toLowerCase() === "frames";
  const price = isFrame
    ? (product.smallframeprice ?? product.smallFrameprice ?? product.price ?? 0)
    : (product.price ?? 0);

  return {
    productId: product.id,
    price,
    category: product.category,
  };
};

export const getWishlist = async (user) => {
  if (user?.email) {
    const q = query(collection(db, "Users"), where("User", "==", user.email));
    const snapshot = await getDocs(q);
    if (snapshot.empty) return [];
    const userDoc = snapshot.docs[0];
    const userData = userDoc.data();
    let list = Array.isArray(userData.wishlist) ? userData.wishlist : [];
    // normalize legacy entries that used `id` instead of `productId`
    list = list.map((item) => {
      if (item.productId == null && item.id != null) {
        return { ...item, productId: item.id };
      }
      return item;
    });
    return list;
  }

  return JSON.parse(localStorage.getItem("wishlist")) || [];
};

export const addToWishlist = async (product, user) => {
  const wishlistItem = normalizeWishlistItem(product);

  if (user?.email) {
    const q = query(collection(db, "Users"), where("User", "==", user.email));
    const snapshot = await getDocs(q);
    if (snapshot.empty) return [];

    const userDoc = snapshot.docs[0];
    const userData = userDoc.data();
    const userId = userDoc.id;

    let wishlist = Array.isArray(userData.wishlist) ? [...userData.wishlist] : [];
    // normalize old entries with `id`
    wishlist = wishlist.map((item) => {
      if (item.productId == null && item.id != null) {
        return { ...item, productId: item.id };
      }
      return item;
    });

    const exists = wishlist.some((item) => item.productId === wishlistItem.productId);
    if (!exists) {
      wishlist.push(wishlistItem);
      await updateDoc(doc(db, "Users", userId), { wishlist });
    }

    return wishlist;
  }

  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  // normalize legacy `id` entries
  wishlist = wishlist.map((item) => {
    if (item.productId == null && item.id != null) {
      return { ...item, productId: item.id };
    }
    return item;
  });
  const exists = wishlist.some((item) => item.productId === wishlistItem.productId);
  if (!exists) {
    wishlist.push(wishlistItem);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }
  return wishlist;
};

export const removeFromWishlist = async (productId, user) => {
  if (user?.email) {
    const q = query(collection(db, "Users"), where("User", "==", user.email));
    const snapshot = await getDocs(q);
    if (snapshot.empty) return [];

    const userDoc = snapshot.docs[0];
    const userData = userDoc.data();
    const userId = userDoc.id;

    const wishlist = Array.isArray(userData.wishlist) ? [...userData.wishlist] : [];
    const updatedWishlist = wishlist.filter((item) => item.productId !== productId);

    await updateDoc(doc(db, "Users", userId), { wishlist: updatedWishlist });
    return updatedWishlist;
  }

  const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  const updatedWishlist = wishlist.filter((item) => item.productId !== productId);
  localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));
  return updatedWishlist;
};
